'use client';
import { getCookie, setCookie } from '#pplx/frontend/cookies/provider.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useCallback, useState } from 'react';
// Bumped from `-v2` so devices carrying the previous 24h dismissal see the
// banner again under the new 4h cadence — we are forcing migration off the
// unsupported legacy app.
const DISMISSED_COOKIE = 'new-app-upsell-banner-dismissed-v3';
const DISMISSED_COOKIE_EXPIRY_HOURS = 4;
const DISMISSED_COOKIE_EXPIRY_DAYS = DISMISSED_COOKIE_EXPIRY_HOURS / 24;
export const useWindowsLegacyAppUpsellBannerPlan = (enabled) => {
    const { device: { isWindowsApp }, } = useWebPlatform();
    const [hidden, setHidden] = useState(() => getCookie(DISMISSED_COOKIE) === '1');
    const isEligibleDevice = enabled && isWindowsApp && !hidden;
    // Same 4h cookie regardless of which button the user clicked. Opening the
    // installer is no proof the user migrated, so we don't reward it with a
    // longer cooldown: if they're still on the legacy app 4h later, we nudge
    // them again.
    const dismiss = useCallback(() => {
        setCookie(DISMISSED_COOKIE, '1', { expires: DISMISSED_COOKIE_EXPIRY_DAYS });
        setHidden(true);
    }, []);
    return {
        dismiss,
        reservesSlot: isEligibleDevice,
        show: isEligibleDevice,
    };
};
//# sourceMappingURL=useWindowsLegacyAppUpsellBannerPlan.js.map